<template>
    <div>
        <div class="content">
		<div class="top">

			<img src="../assets/phone.png" />
			<a href="tel:400-136-3666">
				<h2>400-136-3666</h2>
			</a>
			<p>点击呼叫客服</p>
			<p>工作时间：上午8:00-11:30 <br>
				下午13:30-18:00（法定节假日休息）</p>
			<!-- <p>节假日休息</p> -->
		</div>
		<div class="bottom">
			<div class="b_content">
				<p>如需要文字、语音或图片咨询客服，请进入到公众号界面，按左下角的小键盘进行输入，如下图所示</p>
				<img src="../assets/tip.png" />
			</div>
		</div>
	</div>
    </div>
</template>
<script>
export default {
    name:'hotline',
    data(){
        return{

        }
    }
}
</script>
<style>
        .top {
			width: 100%;
			height: 220px;
			background: #ffffff;
			text-align: center;
			padding-top: 60px;
			padding-bottom: 20px;
		}

		.top img {
			width: 90px;
			height: 90px;
			display: inline-block;
			margin-bottom: 10px;
			/*margin: 0 auto;*/
		}

		.top h2 {
			color: #2C97F7;
			font-weight: 400;
		}

		.top p {
			padding-top: 3px;
			color: #666666;
		}

		.bottom {
			width: 100%;
			height: 300px;
			background: #FFFFFF;
			margin-top: 10px;
		}

		.b_content {
			width: 80%;
			margin: 0 auto;
		}

		.bottom p {
			margin: 0 auto;
			text-align: center;
			padding-top: 50px;
			font-size: 17px;
			color: #999999;
			line-height: 26px;
		}

		.bottom img {
			padding-top: 15px;
			width: 100%;
			display: inline-block;
		}

		a {
			text-decoration: none;
		}
</style>


